export default class Route {
    public static get BrokenRoutePrefix(): string {
        return '';
    }

    public static get AppPrefix(): string {
        return '/app/';
    }

    public static get OrderTracker(): string {
        return '/order-tracker';
    }

    public static get OrdersRoute(): string {
        return 'orders';
    }

    public static get OrderDetailsRoute(): string {
        return 'orders/:orderNumber';
    }

    public static get OrderDetailsRouteNew(): string {
        return 'order/:cidn/:orderNumber';
    }

    public static get OrderProductSheetSubUrl(): string {
        return 'product/:productNumber/:tab';
    }

    public static get OrderDetailsProductSheetFullUrl(): string {
        return Route.OrderDetailsRouteNew + '/' + Route.OrderProductSheetSubUrl;
    }

    public static get OrderListProductSheetFullUrl(): string {
        return Route.OrdersRoute + '/' + Route.OrderProductSheetSubUrl;
    }

    public static get OrderDetailsProgressRoute(): string {
        return 'orders/:orderNumber/progress';
    }

    public static ViewOrders(): string {
        return Route.OrderTracker;
    }

    public static ViewOrderDetails(orderNumber: string): string {
        return Route.OrderDetailsRoute
            .replace(':orderNumber', orderNumber);
    }

    public static ViewOrderDetailsNew(orderNumber: string, cidn: string): string {
        return Route.OrderDetailsRouteNew
            .replace(':orderNumber', orderNumber)
            .replace(':cidn', cidn);
    }

    public static ViewOrderProductSheet(productNumber: string, tab: string): string {
        return Route.OrderProductSheetSubUrl
            .replace(':productNumber', productNumber)
            .replace(':tab', tab);
    }

    public static ViewOrderDetailsProgress(orderNumber: string): string {
        return Route.OrderDetailsProgressRoute
            .replace(':orderNumber', orderNumber);
    }

    public static get OrderListBase(): string {
        return 'tracking/orders';
    }

    public static TrackingOrdersTab(): string {
        return `/${Route.OrderListBase}`;
    }

    public static submitEnquiryForm(isInternational: boolean, reference: string,
        defaultCidn?: string, selectedCidn?: string, subCategory?: string) {
        // TODO: Need to check form path with Indigo team
        const formPath = 'new-enquiry-form';
        if (isInternational && defaultCidn && selectedCidn) {
            return (
                `/customer-support/${formPath}?category=Your orders` +
                `&reference=${reference}&selectedCidn` +
                `=${selectedCidn}&defaultCidn=${defaultCidn}` +
                `&subCategory=${subCategory}`
            );
        } else {
            return (
                `/customer-support/${formPath}?category=Your orders` +
                `&reference=${reference}`
            );
        }
    }

    public static enquiryDetail(caseId?: string, cidn?: string) {
        return `/customer-support/enquiry/${caseId}/detail?category=Order_Enquiry&selected_cidn=${cidn}`;
    }
}
